import { action } from "satcheljs";

import type { OwaNovaActionUnion } from "../types";

export const onImportContacts = action("onImportContacts", event => ({
    event,
    owaType: "importContacts",
})) as OwaNovaActionUnion<"importContacts">;
